import React from 'react';

function SidenavMenu({ children }: React.PropsWithChildren) {
  return (
    <ul className="space-y-2 font-medium">{children}</ul>
  );
}

export default SidenavMenu;
